"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.required = void 0;
const utils_common_1 = require("@agilepoint/utils-common");
const messages_1 = require("./messages");
function required(value) {
    if ((0, utils_common_1.isNullOrUndefined)(value) || !value) {
        return messages_1.messages.required;
    }
    return undefined;
}
exports.required = required;
//# sourceMappingURL=required.js.map